import { RetailerStoresPath } from '@/modules/retailer/paths';
import { Navigate } from 'react-router-dom';

const Home = () => <Navigate to={RetailerStoresPath} replace />;

export default Home;
